import { z } from "zod";

import { CampaignWithIdSchema } from "../../../dtos/deprecated/campaigns";
import { castToBool } from "../../../utils";

export const GetCampaignRequestQueryParamSchema = z.object({
  includeCampaignNamesInSameFunction: castToBool.optional(),
});

export type GetCampaignRequestQueryParamType = z.infer<
  typeof GetCampaignRequestQueryParamSchema
>;

export const GetCampaignRequestPathParamSchema = z.object({
  campaignId: z.string().uuid(),
});

export type GetCampaignRequestPathParamType = z.infer<
  typeof GetCampaignRequestPathParamSchema
>;

export const GetCampaignResponseBodySchema = z.object({
  campaign: CampaignWithIdSchema,
});

export type GetCampaignResponseBodyType = z.infer<
  typeof GetCampaignResponseBodySchema
>;
